import { render } from "./PublicationCollaborationAdDetails.vue.js?vue&type=template&id=2f9f73aa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborationAdDetails.vue?vue&type=template&id=2f9f73aa"
import script from "./PublicationCollaborationAdDetails.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborationAdDetails.vue?vue&type=script&lang=js"
export * from "./PublicationCollaborationAdDetails.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborationAdDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/PublicationCollaborationAdDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f9f73aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f9f73aa', __exports__)) {
    api.reload('2f9f73aa', __exports__)
  }
  
  module.hot.accept("./PublicationCollaborationAdDetails.vue.js?vue&type=template&id=2f9f73aa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaborationAdDetails.vue?vue&type=template&id=2f9f73aa", () => {
    api.rerender('2f9f73aa', render)
  })

}


export default __exports__